import React from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";

interface MessageAlertProps {
  open: boolean;
  type?: AlertColor; // 'success' | 'error' | 'info' | 'warning'
  message: string;
  duration?: number;
  onClose: () => void;
}

const MessageAlert: React.FC<MessageAlertProps> = ({
  open,
  type = "info",
  message,
  duration = 3000,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity={type} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MessageAlert;
